var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.166 17.7082H5.83268C2.79102 17.7082 1.04102 15.9582 1.04102 12.9165V7.08317C1.04102 4.0415 2.79102 2.2915 5.83268 2.2915H14.166C17.2077 2.2915 18.9577 4.0415 18.9577 7.08317V12.9165C18.9577 15.9582 17.2077 17.7082 14.166 17.7082ZM5.83268 3.5415C3.44935 3.5415 2.29102 4.69984 2.29102 7.08317V12.9165C2.29102 15.2998 3.44935 16.4582 5.83268 16.4582H14.166C16.5493 16.4582 17.7077 15.2998 17.7077 12.9165V7.08317C17.7077 4.69984 16.5493 3.5415 14.166 3.5415H5.83268Z",
    fill: "#026C96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 13.1248C8.27435 13.1248 6.87435 11.7248 6.87435 9.99984C6.87435 8.27484 8.27435 6.87484 9.99935 6.87484C11.7243 6.87484 13.1243 8.27484 13.1243 9.99984C13.1243 11.7248 11.7243 13.1248 9.99935 13.1248ZM9.99935 8.12484C8.96602 8.12484 8.12435 8.9665 8.12435 9.99984C8.12435 11.0332 8.96602 11.8748 9.99935 11.8748C11.0327 11.8748 11.8743 11.0332 11.8743 9.99984C11.8743 8.9665 11.0327 8.12484 9.99935 8.12484Z",
    fill: "#026C96"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8327 6.45817H13.3327C12.991 6.45817 12.7077 6.17484 12.7077 5.83317C12.7077 5.4915 12.991 5.20817 13.3327 5.20817H15.8327C16.1743 5.20817 16.4577 5.4915 16.4577 5.83317C16.4577 6.17484 16.1743 6.45817 15.8327 6.45817Z",
    fill: "#026C96"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 14.7915H4.16602C3.82435 14.7915 3.54102 14.5082 3.54102 14.1665C3.54102 13.8248 3.82435 13.5415 4.16602 13.5415H6.66602C7.00768 13.5415 7.29102 13.8248 7.29102 14.1665C7.29102 14.5082 7.00768 14.7915 6.66602 14.7915Z",
    fill: "#026C96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.c26b4c0e5630f4764157a95fea4ea6c7.svg";
export { ForwardRef as ReactComponent };